import { Provider } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { API } from '../../api/api';
import { apiURL } from '../../config';
import { AppFooter } from './app-footer';
import { AppHeader } from './app-header';

export class AppInner extends React.Component<RouteComponentProps<void>> {
  private readonly api = new API(apiURL);

  public render() {
    return (
      <Provider api={this.api}>
        <div className="app">
          <AppHeader/>
          {this.props.children}
          <AppFooter/>
        </div>
      </Provider>
    );
  }
}

export const App = withRouter(AppInner) as React.ComponentClass;

export interface InjectAPI {
  readonly api: API;
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/app/app.tsx